import { render, staticRenderFns } from "./ApproveDispatch.vue?vue&type=template&id=6f65e318"
import script from "./ApproveDispatch.vue?vue&type=script&lang=js"
export * from "./ApproveDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports